import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import { FOERDERPROGRAMM_ABSCHLUSS_TEXTE_PATHS } from 'src/lib/constants/componentsPath';
import { ABSCHLUSS_HINWEISE_TABS, ANTRAG_TYP, ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import GetAbschlussContent from './GetAbschlussContent';
import { getFormStrucAbschlussFoerderungBeantragen } from './content/AbschlussFoerderungBeantragen';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragAbschlussSeiteGlobal = (application: any, _readOnly: boolean): TreeNodeType[] => {
	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;

	let treeNodes: TreeNodeType[] = [
		{
			label:
				antragsTyp === ANTRAG_TYP.Skizze ? 'Skizze einreichen'
				: isFormantrag ? 'Formantrag einreichen'
				: 'Antragseinreichung',
			content: (
				<ApplicationHeading
					title={
						antragsTyp === ANTRAG_TYP.Skizze ? 'Skizze einreichen'
						: isFormantrag ?
							'Formantrag einreichen'
						:	'Antragseinreichung'
					}
				/>
			),
			...GetAbschlussStructure(application),
		},
	];

	return treeNodes;
};

const GetAbschlussStructure = (application: any) => {
	let abschlussChildren = {};

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;

	const foerderprogramm = get(application, P.Foerderprogramm.path, {});

	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ABSCHLUSS_TEXTE_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ABSCHLUSS_TEXTE_PATHS.Formantrag
		: FOERDERPROGRAMM_ABSCHLUSS_TEXTE_PATHS.Antrag;

	const hinweisBlockSorted = sortAbschlussHinweisBlock(get(foerderprogramm, paths.AbschlussTexteBlock, []));

	const children: TreeNodeType[] = hinweisBlockSorted.map((ele: any, i: number) => {
		const tab = get(ele, paths.Tab, '');

		return {
			label: `${tab !== ABSCHLUSS_HINWEISE_TABS.Weitere ? Roman.toRoman(i + 1) + '. ' : ''} ${get(ele, paths.Titel, '')}`,
			content: <GetAbschlussContent hinweis={ele} paths={paths} />,
			formStruc:
				get(ele, paths.Tab) === ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen ? getFormStrucAbschlussFoerderungBeantragen(application) : [],
		};
	});

	if (children.length > 0) {
		abschlussChildren = {
			children: children,
		};
	}

	return abschlussChildren;
};

function sortAbschlussHinweisBlock(hinweisArray: any[]) {
	const tabOrder = Object.values(ABSCHLUSS_HINWEISE_TABS).filter((tab) => tab !== 'Weitere');

	// "Gültige" Hinweise nach tabOrder sortieren
	const andereHinweise = hinweisArray.filter((item) => item.Tab && item.Tab !== 'Weitere');
	const weitereHinweise = hinweisArray.filter((item) => !item.Tab || item.Tab === 'Weitere');

	const sortierteAndereHinweise = tabOrder.map((tab) => andereHinweise.find((item) => item.Tab === tab)).filter(Boolean);

	return [...sortierteAndereHinweise, ...weitereHinweise];
}
